import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String }

  connect() {
    if (typeof Intercom != "undefined") {
      Intercom("trackEvent", this.nameValue)

      console.info("Tracked Intercom event: " + this.nameValue)
    }
  }
}
